import './App.css';
import AdminInviteView from './pages/AdminInviteView';
import { AuthProvider } from './context/AuthContext';
import EventsView from './pages/EventsView';
import FightsView from './pages/FightsView';
import FighterView from './pages/FighterView';
import AppLayout from './components/layout/AppLayout';
import LoginView from './pages/LoginView';
import RegisterView from './pages/RegisterView';
import React from 'react';
import RequireAuth from './components/auth/RequireAuth';
import RequireAdmin from './components/auth/RequireAdmin';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/login" element={<LoginView />} />
            <Route path="/register" element={<RegisterView />} />
            <Route element={<RequireAuth />}>
              <Route path="/" element={<EventsView />} />
              <Route path="/event/:id/fights" element={<FightsView />} />
              <Route path="/fighter/:id" element={<FighterView />} />
              <Route element={<RequireAdmin />}>
                <Route path="/admin/invite" element={<AdminInviteView />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
